import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ResponseService } from '../../models/response-service.model';
import { userData } from 'src/app/core/models/user/user.models';
import { UtilsService } from '../utils/utils.service';
import { getFirebaseBackend } from '../../../authUtils';
import dayjs from 'dayjs';


@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient, private utils: UtilsService) { }

  public getProfile(userId: number){
    const url = `${environment.api}user/${userId}/get_profile`;
    return this.http.get<ResponseService>(url);
  }

  public updateProfile(idUser: number, dataUser:userData){
    var formData: any = new FormData();
    formData.append('user_id', idUser);
    formData.append('first', dataUser.first);
    formData.append('last', dataUser.last);
    formData.append('phone_mobile', dataUser.phone_mobile);
    formData.append('address', dataUser.address);
    formData.append('city', dataUser.city);
    formData.append('state', dataUser.state);
    formData.append('zip_code', dataUser.zip_code);

    const url = `${environment.api}user/update_profile`;
    var response= this.http.post<ResponseService>(url, formData);

    return response;
  }

  public autoSignUp(payload){
    const url = `${environment.api}user/auto_sign_up`;
    var formData = this.utils.jsonToFormData(payload);
    return this.http.post<ResponseService>(url, formData);
  }

  public getCredit(user_id: number){
    const url = `${environment.api}user/${user_id}/get_credit`;
    return this.http.get<ResponseService>(url);
  }

  saveAction(action: string) {
	const user = getFirebaseBackend()?.getAuthenticatedUser();
		const payload = {
			user_id: user?.IdUser,
			action_description: action,
			ipv4: user?.ipv4,
			ipv6: user?.ipv6,
			portal: 'CUS'
		}

		const url = `${environment.api}utils/save_user_action`;
		const formData = this.utils.jsonToFormData(payload);

		this.http.post<ResponseService>(url, formData).subscribe(
			(data) => {
				console.info('Action saved', data);
			},
			(error) => {
				console.error('Error saving action', error);
			}
		);
	}

}
